import React, { useState, useEffect } from 'react';

import { useParams } from 'react-router-dom';

import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import backgroundLines from '../assets/linesbackground.png';
import Box from '@mui/material/Box';
import mainURL from '../config/environment';
import $ from 'jquery';

import { useNavigate } from 'react-router-dom';
import Toolbar from '@mui/material/Toolbar';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import MapCard from '../components/cards/mapCard';

export default function MapModule(props) {
  const [maps, setMaps] = useState([]);
  const { clientId } = useParams();
  const navigate = useNavigate();

  const [searchText, setSearchText] = useState('');
  const [filteredData, setFilteredData] = useState([]);

  const handleSearch = (event) => {
    const target = event.target;
    const value = target.value;
    setSearchText(value);
  };

  const handleNavigate = (mapId) => (event) => {
    navigate(`/${clientId}/${mapId}`);
  };

  useEffect(() => {
    const token = JSON.parse(localStorage.getItem('userInfo')).token;
    let isSubscribed = true;
    //handleShowNotification("info", "Loading users");
    $.ajax({
      method: 'GET',
      url: `${mainURL}map/get-all`,
      contentType: 'application/json',
      headers: {
        Authorization: 'Bearer ' + token,
      },
    })
      .done((res) => {
        if (isSubscribed) {
          const aux = clientId === undefined ? res : res.filter((map) => map.clientId === clientId);
          setMaps(aux);
          setFilteredData(aux);
        }
      })
      .fail((res) => {});
    return () => (isSubscribed = false);
  }, [clientId]);

  useEffect(() => {
    const myReg = new RegExp('^.*' + searchText.toLowerCase() + '.*');
    const newArray = maps.filter((f) => f.mapTitle.toLowerCase().match(myReg));
    setFilteredData(newArray);
  }, [maps, searchText]);

  return (
    <Box
      height="100%"
      sx={{
        backgroundImage: `url(${backgroundLines})`,
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        backgroundRepeat: 'repeat-y',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        backgroundColor: '#eef8fe',
      }}
    >
      <Grid container spacing={2} padding={2}>
        <Grid item xs={12} sx={{ display: { xs: 'block', sm: 'none' } }}>
          <Toolbar variant="dense">
            <FormControl fullWidth>
              <TextField
                label={'Search by name'}
                variant="standard"
                onChange={handleSearch}
                value={searchText}
                InputProps={{
                  startAdornment: <SearchIcon color="action" />,
                  endAdornment: (
                    <IconButton size="small" onClick={() => setSearchText('')}>
                      <ClearIcon color="action" />
                    </IconButton>
                  ),
                }}
              />
            </FormControl>
          </Toolbar>
        </Grid>
        {filteredData.map((map) => (
          <Grid key={map.id} sx={{ p: 2 }} item xs={12} sm={6} md={4}>
            <MapCard map={map} handleNavigate={handleNavigate} />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}

/*  */
